import { brandKitProxy } from '@goldcast/api/backend';

import { BrandKitGetters } from './getters';
import { BrandKitMutations } from './mutations';
import { BrandKitState } from './types';

import loggerService from '@/services/logger.service';

export interface BrandKitContext {
  state: BrandKitState;
  getters: BrandKitGetters;
  commit: <k extends keyof BrandKitMutations>(mutation: k, payload?: any, config?: { root: boolean }) => any;
  dispatch: (action: string, payload?: any, root?: { root: boolean }) => Promise<any>;
}

const actions = {
  fetchBrandKit(context: BrandKitContext, orgId: string) {
    brandKitProxy({
      id: orgId,
      queryParams: {
        limit: 1,
        offset: 0
      }
    })
      .then(brandKit => {
        context.commit('setBrandKit', { brandKit, orgId });
      })
      .catch((error: Error) => {
        loggerService.error('Error fetching brand kit', error);
      });
  }
};

export default actions;
